import { useDispatch, useSelector } from "react-redux"
import * as cartSlice from "../../store/cart"
import { getSrc } from "../../utilities/enumerations/constants"

export default function DealCard({ item }) {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)

  const sale = item.price - item.discount

  return (
    <div className="col">
      <div className="card rounded-4 shadow-none h-100">
        <div className="position-relative border-bottom">
          <img src={getSrc(item.thumbnail_url)} className="card-img-top rounded-top-4" alt={item.title} />
          <div className="btn-group btn-group-sm rounded-3 d-inline-block ms-auto m-1" role="group">
            {
              cartState.posById[item.slug] > 0 && <>
                <button type="button" className="btn btn-light-danger" onClick={() => dispatch(cartSlice.handlePosDecrement(item.slug))}><i className={`bi bi-${cartState.posById[item.slug] === 1 ? "x" : "dash"}-lg`}></i></button>
                <button className="btn btn-secondary">{cartState.posById[item.slug]}</button>
                <button type="button" className="btn btn-light-theme" onClick={() => dispatch(cartSlice.handlePosIncrement(item.slug))}><i className="bi bi-plus-lg"></i></button>
              </>
            }
            {!cartState.posById[item.slug] && <button type="button" className="btn btn-light-theme rounded-3" onClick={() => dispatch(cartSlice.addToPos({ ...item, type: "deal" }))}><i className="bi bi-plus-lg"></i></button>}
          </div>
        </div>
        <div className="card-body p-3">
          <h6 className="small text-body-emphasis fw-bold m-0">{item.title}</h6>
          <p className="small text-body-tertiary fw-semibold m-0">Rs. {sale.toFixed(2)}</p>
        </div>
      </div>
    </div>
  )
}